import React from 'react';
import { PageTitle } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import { Deck } from '~/components/Resource';

const ResourceCollection = () => {
  const params = useParams();

  return (
    <>
      <PageTitle>Resources</PageTitle>

      <Deck
        params={{
          patient_uid: params.patient_id,
        }}
      />
    </>
  );
};

export default ResourceCollection;
